import React, { Component, PropTypes } from 'react';
import Clip from '../../../../common/svgs/Clip';

export default class ItemAttachment extends Component {
  static propTypes = {
    removeAttachment : PropTypes.func.isRequired,
    fileName: PropTypes.string.isRequired
  }

  constructor(props, context) {
    super(props, context);
  }

  render() {

    return (
      <div className='item-attachment'>
        <Clip className='clip-icon'/>
        <span data-id='filename' className='file-name'>{this.props.fileName}</span>
        <span data-id='close button' className='close-button' onClick={this.props.removeAttachment(this.props.fileName)}></span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Emails/ItemAttachment/index.js